import { auth } from "@/config/firebase"

export const useFetchWithAuth = async (url, options = {}) => {
  const idToken = await auth.currentUser.getIdToken(true);
  const response = await fetch(`${process.env.VUE_APP_API_ROOT}${url}`, {
    method: 'GET',
    ...options,
    headers: {
      'Authorization': 'Bearer ' + idToken,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  const data = await response.json();
  return data;
}

export const useFetch = async (url, options = {}) => {
  const response = await fetch(`${process.env.VUE_APP_API_ROOT}${url}`, {
    method: 'GET',
    ...options,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  const data = await response.json();
  return data;
}

/* resource */
export async function getSignedDownloadUrl(filePath) {
  return await useFetch(`/resource/signed-download-url?filePath=${encodeURIComponent(filePath)}`);
}

/* Audio */
export async function convertSessionToMp3Format(uid, sessionKey) {
  return await useFetchWithAuth(`/audio/convert`, {
    method: 'POST',
    body: JSON.stringify({
      session_key: sessionKey,
      uid: uid,
    }),
  });
}

export async function clipSessionToSong(uid, sessionKey, songKey, startTime, endTime) {
  return await useFetchWithAuth(`/audio/clip`, {
    method: 'POST',
    body: JSON.stringify({
      session_key: sessionKey,
      uid: uid,
      song_key: songKey,
      start_time: startTime,
      end_time: endTime,
    }),
  });
}

export async function separateSong(uid, sessionKey, songKey, splitKey, inBrowser) {
  return await useFetchWithAuth(`/audio/separate`, {
    method: 'POST',
    body: JSON.stringify({
      session_key: sessionKey,
      uid: uid,
      song_key: songKey,
      split_key: splitKey,
      in_browser: inBrowser ? 'true' : 'false',
    }),
  });
}

export async function createSongVideo(uid, sessionKey, songKey, videoKey, templateKey, songName, ownerName, inBrowser) {
  return await useFetchWithAuth(`/audio/create-video`, {
    method: 'POST',
    body: JSON.stringify({
      uid: uid,
      session_key: sessionKey,
      song_key: songKey,
      video_key: videoKey,
      template_key: templateKey,
      song_name: songName,
      owner_name: ownerName,
      in_browser: inBrowser ? 'true' : 'false',
    }),
  });
}

export async function createVideoThumbnail(uid, songKey, videoKey) {
  return await useFetchWithAuth(`/audio/create-video-thumbnail`, {
    method: 'POST',
    body: JSON.stringify({
      uid: uid,
      song_key: songKey,
      video_key: videoKey,
    }),
  });
}

export async function createTemplateThumbnail(uid, templateKey) {
  return await useFetchWithAuth(`/audio/create-template-thumbnail`, {
    method: 'POST',
    body: JSON.stringify({
      uid: uid,
      template_key: templateKey,
    }),
  });
}

/* Admin */
export async function deleteUser(uid) {
  return await useFetchWithAuth(`/admin/delete-user`, {
    method: 'POST',
    body: JSON.stringify({
      uid: uid,
    }),
  });
}

export async function revokeUser(uid) {
  return await useFetchWithAuth(`/admin/revoke-user`, {
    method: 'POST',
    body: JSON.stringify({
      uid: uid,
    }),
  });
}
